import type { TEntityUpdateStatus } from 'entities/post'

export const HOURS_SINCE_LAST_UPDATE_THRESHOLD = 24
export const TWO_WEEKS_IN_MS = 14 * 24 * 60 * 60 * 1000

export const ENTITY_UPDATE_STATUS = {
  SUCCESS: 'SUCCESS',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
} satisfies Record<string, TEntityUpdateStatus>
